<template>
  <q-list class="tm-list">
    <slot />
  </q-list>
</template>
